import { useTranslation } from 'react-i18next';
import LegalPage from '../components/LegalPage/LegalPage';
import { FALLBACK_LANGUAGE } from '../i18n/config';
import { useLegalDocument, type LegalDocumentKey } from '../i18n/useLegalDocument';
import { useLanguage } from '../i18n/useLanguage';
import { usePageMeta } from '../hooks/usePageMeta';

export default function Legal({ documentKey }: { documentKey: LegalDocumentKey }) {
    const { i18n } = useTranslation();
    const { language } = useLanguage();
    const legalDocument = useLegalDocument(documentKey);
    const hasOwnTranslation = i18n.exists(`legal.${documentKey}`, { lng: language, fallbackLng: [] });
    usePageMeta(`${legalDocument.title} | Haukel`, legalDocument.subtitle);

    return <LegalPage content={legalDocument} contentLanguage={hasOwnTranslation ? language : FALLBACK_LANGUAGE} />;
}
